import React, { useState, useEffect } from 'react';
import { ComparisonSlider } from 'react-comparison-slider';
import Header from '../Header';
import { whiteningResultImage } from '../../../Services/APIs/scan';
import bag from "../../../assets/unilever-media/bag.png"
import tiktok from "../../../assets/unilever-media/tiktok.png"
import { CircularProgress } from '@mui/material';
// import 'react-comparison-slider/dist/style.css';
import { logData } from '../../../Services/APIs/scan';
import controller from "../../../assets/unilever-media/Controller.png"

const ImageSlider = () => {

    const [images, setImages] = useState([]); // State to store fetched images
    const [error, setError] = useState(null); // Error state
    const [loading, setLoading] = useState(false);
    const uid = JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi;
    const company = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket;

    useEffect(() => {
        getImageData();
        logData({uid, company, message: "visited image slider"})
    }, []);


    // Function to fetch images from the API and convert to URLs
    const getImageData = async () => {
        try {
            setLoading(true);
            const res = await whiteningResultImage();
            const imageArray = res.data.data;
            // console.log(imageArray)
            // Convert each binary image data to a URL
            const fetchedImages = imageArray.map((binaryImage) => {
                const byteArray = new Uint8Array(binaryImage.data);
                const blob = new Blob([byteArray], { type: "image/jpeg" }); // Adjust type if necessary
                return URL.createObjectURL(blob); // Create URL for each image
            });
            setImages(fetchedImages); // Store image URLs in state
            setLoading(false);
        } catch (err) {
            console.log("Error fetching images:", err);
            setError("Failed to fetch images.");
            setLoading(false);
            //   navigate('/')
        }

    };

    const handleBuyNowClick = () => {
        logData({uid, company, message: "clicked on buy now"})
        window.open("https://www.tanyapepsodent.com/rangkaian-produk/ultra-white.html", "_self");
    }

    // const handleTryNowClick = () => {
        // logData({uid, company, message: "clicked on try now"})
        // window.open("https://www.tanyapepsodent.com/ultra-white/try-now.html", "_self");
    // }


    return (
        <div className="bg-gradient-to-t from-[#570103] to-[#9F6D6E] min-h-full flex flex-col items-center text-white font-sans">
            <Header />
            <main className="w-full max-w-md md:max-w-xl p-4 flex-grow flex flex-col items-center justify-center">
                <div className="text-center mb-4">
                    <h1 className="md:max-w-xl mx-auto text-4xl font-CirceRounded-Regular font-bold">
                     <span className="font-normal md:text-[40px]">Slide left to see your 5 Shades Whiter Teeth</span></h1>
                    <p className="md:w-[100vw] text-sm font-CirceRounded-Light mt-3 md:text-lg">Below is the result of your teeth whitening with Pepsodent Ultra White in 7 Days. </p>
                    <p className="text-sm font-CirceRounded-Light mt-3 md:text-lg">Screenshot to track your progress!</p>
                </div>
                <div className="w-full min-h-[350px] relative">
                    {
                        loading ? <div className="w-full h-[300px] flex items-center justify-center"><CircularProgress size={20} color='white' /></div> : error ? <p className="pt-10 text-center text-white">{error}</p> :
                            <ComparisonSlider
                                defaultValue={50}
                                itemOne={<img src={images[0]} alt="Before" className="w-full h-full object-contain" />}
                                itemTwo={<img src={images[1]} alt="After" className="w-full h-full object-contain" />}
                                aspectRatio={1}
                                orientation="horizontal"
                                className="w-full h-full relative"
                                handleBefore={<div className="w-0.5 h-full bg-white/80 absolute top-0 left-1/2 transform -translate-x-1/2" />}
                                handleAfter={<div className="w-0.5 h-full bg-white/80 absolute top-0 left-1/2 transform -translate-x-1/2" />}
                               
                                handle={() => (
                                    <div className="flex items-center justify-center w-8 h-8 -ml-4 -mt-3 absolute top-1/2 left-1/2">
                                        <img 
                                            src={controller} 
                                            alt="slider control" 
                                            className="w-8 h-8 object-contain"
                                            draggable={false}
                                        />
                                    </div>
                                )}
                                onPositionChange={(position) => console.log(position)}
                                style={{
                                    '--default-handle-opacity': 0,
                                    '--default-handle-width': '0px',
                                }}
                            />
                            
                    }
                </div>
                <div className="text-center mt-4">
                    <p className="text-sm font-CirceRounded-Light md:text-lg">Adjust slider to see the changes</p>
                </div>
                <div className="w-full px-4 py-2 mt-4  rounded-lg text-center md:text-lg">
                    <p className=" font-CirceRounded-Light text-white/80">Disclaimer</p>
                    <p className=" font-CirceRounded-Light text-white/80">
                        Dibuatkan oleh AI, dan hasil dapat bervariasi pada
                        
                        konsumen sesuai dengan penggunaan. Harap baca
                        
                        petunjuk penggunaan.
                    </p>
                </div>
                <div className="mt-2 space-y-4 px-4 w-full max-w-md mb-8">
                    <button
                        onClick={handleBuyNowClick}
                className="w-full bg-[#D50026] text-white py-3 rounded-full text-lg font-CirceRounded-Regular font-semibold flex items-center justify-center">
                    <img src={bag} alt="bag" className="h-5" />
                    <span className="ml-2 md:text-xl">Buy Now</span>
                    </button>
                {/* <button 
                // onClick={handleTryNowClick}
                className="w-full bg-white text-[#D50026] py-3 rounded-full text-lg font-CirceRounded-Regular font-semibold flex items-center justify-center">
                    <img src={tiktok} alt="tiktok" className="h-5" />
                    <span className="ml-2">Try our TikTok Filter now</span>
                </button> */}
                </div>
            </main>
        </div>
    );
};

export default ImageSlider;